/** @format */

export * from './product-card-image-swatches.component';
